import { useParams } from "react-router-dom";

import AOPMaltaAdmissionLayout from "@/src/components/AdmissionsOfficePage/Malta/AdmissionLetter/En/AOPMaltaAdmissionLayout";
import AOPMaltaInvoiceLayout from "../components/AdmissionsOfficePage/Malta/InvoiceLetter/En/AOPMaltaInvoiceLayout";
import AOPMaltaAcknowledgementLayout from "@/src/components/AdmissionsOfficePage/Malta/AcknowledgementLetter/En/AOPMaltaAcknowledgementLayout";
import AOPMaltaPaymentConfirmationLayout from "../components/AdmissionsOfficePage/Malta/PaymentConfirmationLetter/En/AOPMaltaPaymentConfirmationLayout";
import AOPMaltaStudentLayout from "../components/AdmissionsOfficePage/Malta/StudentLetter/En/AOPMaltaStudentLayout";
import AOPMaltaCertificateLayout from "../components/AdmissionsOfficePage/Malta/CertificateLetter/En/AOPMaltaCertificateLayout";
////////////////////////////////
import AOPPolandPaymentConfirmationLayout from "../components/AdmissionsOfficePage/Poland/PaymentConfirmationLetter/En/AOPPolandPaymentConfirmationLayout";
import AOPPolandInvoiceLayout from "../components/AdmissionsOfficePage/Poland/InvoiceLetter/En/AOPPolandInvoiceLayout";
import AOPPolandAdmissionLayout from "../components/AdmissionsOfficePage/Poland/AdmissionLetter/En/AOPPolandAdmissionLayout";
import AOPPolandAcknowledgementLayout from "../components/AdmissionsOfficePage/Poland/AcknowledgementLetter/En/AOPPolandAcknowledgementLayout";
////////////////////////////////
import AOPUkrainePaymentConfirmationLayout from "../components/AdmissionsOfficePage/Ukraine/PaymentConfirmationLetter/En/AOPUkrainePaymentConfirmationLayout";
import AOPUkraineInvoiceLayout from "../components/AdmissionsOfficePage/Ukraine/InvoiceLetter/En/AOPUkraineInvoiceLayout";
import AOPUkraineAdmissionLayout from "../components/AdmissionsOfficePage/Ukraine/AdmissionLetter/En/AOPUkraineAdmissionLayout";
import AOPUkraineAcknowledgementLayout from "../components/AdmissionsOfficePage/Ukraine/AcknowledgementLetter/En/AOPUkraineAcknowledgementLayout";
import AOPUkraineRequestLayout from "../components/AdmissionsOfficePage/Ukraine/RequestLetter/En/AOPUkraineRequestLayout";

const AdmissionsOfficePage = () => {
  const { country, document } = useParams<{
    country?: string;
    document?: string;
  }>();

  if (!country || !document) {
    return <div>Not found</div>;
  }

  switch (country) {
    case "malta": {
      switch (document) {
        case "admission":
          return <AOPMaltaAdmissionLayout />;

        case "invoice":
          return <AOPMaltaInvoiceLayout />;

        case "acknowledgement":
          return <AOPMaltaAcknowledgementLayout />;

        case "payment":
          return <AOPMaltaPaymentConfirmationLayout />;

        case "student":
          return <AOPMaltaStudentLayout />;

        case "certificates":
          return <AOPMaltaCertificateLayout />;

        default:
          return <div>Not found</div>;
      }
    }
    case "poland": {
      switch (document) {
        case "admission":
          return <AOPPolandAdmissionLayout />;
        case "invoice":
          return <AOPPolandInvoiceLayout />;
        case "payment":
          return <AOPPolandPaymentConfirmationLayout />;
        case "acknowledgement":
          return <AOPPolandAcknowledgementLayout />;
        default:
          return <div>Not found</div>;
      }
    }
    case "ukraine": {
      switch (document) {
        case "admission":
          return <AOPUkraineAdmissionLayout />;
        case "invoice":
          return <AOPUkraineInvoiceLayout />;
        case "payment":
          return <AOPUkrainePaymentConfirmationLayout />;
        case "acknowledgement":
          return <AOPUkraineAcknowledgementLayout />;
        case "request":
          return <AOPUkraineRequestLayout />;
        default:
          return <div>Not found</div>;
      }
    }
    default:
      return <div>Not found</div>;
  }
};

export default AdmissionsOfficePage;
